import { useQuery } from 'react-query';
import { useSnackbar } from 'notistack';
import { getRecruitmentTeamInfoUrl } from '../../apisPath';
import { fetchApiSimple, getGetConfigSimple } from '../../utils/fetch';
import HomePageQueryKeys from './queryKeys';
import HomePageTransformation from './transformation';

const useGetRecruitmentTeam = () => {
  const { enqueueSnackbar } = useSnackbar();

  return useQuery(HomePageQueryKeys.all, () => fetchApiSimple(getRecruitmentTeamInfoUrl(), getGetConfigSimple()), {
    select: (data) => HomePageTransformation.transformHomePageData(data || {}),
    onError: (error) => enqueueSnackbar(error.message || error.code || 'خطا', { variant: 'error' }),
  });
};

export default useGetRecruitmentTeam;
